import React from 'react';
import { useLocation } from 'react-router-dom';

import useSessionEntity from '../../../hooks/useSessionEntity'
import useRouteStatus from '../../../hooks/useRouteStatus';

import BankCredentials from './BankCredentials';
import CreditCardCredentials from './CreditCardCredentials';
import Loading from '../../shared/Loading';

export default function AddPaymentMethod() {
  const location = useLocation();
  const merchant = useSessionEntity('merchant');

  useRouteStatus(location);

  if (!merchant) return <Loading active={true} />;

  return merchant.bank_bypass ? <CreditCardCredentials /> : <BankCredentials />
}
